import { createSlice } from '@reduxjs/toolkit';
interface IState{
    isUserTabSelected: boolean;
    isSuccess: boolean;
    error: string;
}

/**
 * initial state
 */
const initialState: IState = {
    isUserTabSelected: true,
    isSuccess: false,
    error: '',
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;